import Typography from "@mui/material/Typography";
import styles from "./styles";
import withStyles from '@mui/styles/withStyles';
import tracking from "../../utils/tracking";
import { FormattedMessage } from "react-intl";
import { useEffect } from "react";
import { useScript } from "../../utils/hooks";

const handleSignUpClick = (e) => {
  e.preventDefault();
}

const Subscribe = ({ classes, children, page="thank-you"}) => {
  
  const trackSubscribe = () => {
    tracking.trackSubscribe(page);
  };

  useScript("https://substackapi.com/widget.js");

  useEffect(() => {
    window.CustomSubstackWidget = {
      substackUrl: "rifugiamiata.substack.com",
      placeholder: "you@example.com",
      buttonText: "Iscriviti",
      theme: "custom",
      colors: {
        primary: "#005EA5",
        input: "#039277",
        email: "#000000",
        text: "#FFFFFF",
      }
    };
  }, []);

  return (
    <>
      <div className={classes.container}>
        <div className={classes.subscribe}>
          <div id="subscribe" className={classes.heading}>
          <div className={classes.text}>
            <Typography
                color="inherit" 
                variant="h3"
                component="h3"
                className={classes.intro}
                gutterBottom={true}
              >
                <FormattedMessage id="subscribe.title" defaultMessage="Non possiedi terreni? Iscriviti alla nostra Newsletter!" />
              </Typography>          
              <Typography 
                color="inherit" 
                className={classes.intro} 
                gutterBottom={true}
              >
                <FormattedMessage
                  id="subscribe.alertsOneLiner1"
                  defaultMessage="Anche se non possiedi nessun terreno puoi contribuire a preservare la nostra Montagna ed aiutarci a realizzare il sogno  del Parco Nazionale dell'Amiata. Scopri come iscrivendoti alla nostra newsletter."
                />

              </Typography> 
            </div>
            <div id="custom-substack-embed" className={classes.substack}/>
          </div>
        </div>
      </div>
    </>
  );
};
export default withStyles(styles)(Subscribe);